.checkbox {
	display: inline-flex;
	align-items: center;
	gap: 8px;
	cursor: pointer;
	user-select: none;
	padding: 4px 0;
	color: var(--content-primary);
}

.box {
	width: 16px;
	height: 16px;
	border-radius: 3px;
	border: 1.4px solid var(--border-primary);
	background-color: var(--background-primary);
	flex-shrink: 0;
	display: inline-flex;
	align-items: center;
	justify-content: center;
}

.checkbox[data-hovered] .box {
	border-color: var(--border-hover);
}

.checkbox[data-focus-visible] .box {
	outline: var(--focus-outline);
}

.tick {
	width: 10px;
	height: 10px;
	color: var(--background-primary);
	visibility: hidden;
}

.checkbox[data-selected] .box {
	background-color: var(--background-secondary);
	border-color: var(--background-primary);
}

.checkbox[data-selected] .tick {
	visibility: visible;
}

.label {
	color: var(--content-primary);
}
